<template>
  <div>search results</div>
</template>

<script>
export default {
  name: "SearchResultClinic",
  title: "Search results",
};
</script>